import BaseType from "./BaseType";

export default class Schrank extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
    }

    vsUpdate() {
        this.copyMatrix(this.vsData.matrix);
    }

}

// verdeckung: THREE.Object3D;
// this.verdeckung = new THREE.Group();
// this.add(this.verdeckung);
// if (this.isVsChanged('size') || this.isVsChanged('verdeckungsIntervale')) {
//     this.recreateVerdeckung();
// }
// recreateVerdeckung() {
//     Scenes.empty(this.verdeckung);
//
//     this.vsData.verdeckungsIntervale.forEach(interval => {
//         const size = this.vsData.size;
//         // durch die +10 wird für DebugZwecke die Verdeckung oberhalb des Schranks angezeigt
//         const ueberstand = 10;
//         const planeSize = v3(interval[1] - interval[0], size.y + ueberstand, 0);
//         const geometry = new THREE.PlaneGeometry(planeSize.x, planeSize.y);
//         const material = new THREE.MeshBasicMaterial({
//             color: 0x080000,
//             side: THREE.FrontSide,
//             transparent: true,
//             opacity: 0.1
//         });
//         const plane = new THREE.Mesh(geometry, material);
//         plane.position.set(planeSize.x / 2 + interval[0], planeSize.y / 2, size.z + 0.1);
//         this.verdeckung.add(plane);
//     });
// }
